import { AxiosResponse } from 'axios';
import { Explotacion, Archivo } from '@/models/Explotacion';
import { useExplotacionStore } from '@/stores/store.explotacion';
import { api } from '@/api/axiosConfig';

export default {
  name: 'ExplotacionApi',
  async get(): Promise<Explotacion> {
    const explotacion = await useExplotacionStore().get;
    return api.get('/v2/explotacion/detalle/'+explotacion.id+'?expand=ubicaciones.tipologias').then((response: AxiosResponse) => {
      return response.data;
    });
  },
  async listar(): Promise<Explotacion[]> {
    return api.get('/v2/explotacion/listar?expand=cliente,ganadero,provincia').then((response: AxiosResponse) => {
      return response.data;
    });
  },
  async checkNoConformidad(): Promise<boolean> {
    const explotacion = await useExplotacionStore().get;
    return api.get('/v2/explotacion/check-no-conformidad/'+explotacion.id).then((response: AxiosResponse) => {
      return response.data;
    });
  },
  async checkFacturasPendientes(): Promise<boolean> {
    const explotacion = await useExplotacionStore().get;
    const id_cliente = explotacion.cliente.numero;
    return api.get('/v1/pendientesfacturar?codcli='+id_cliente+'&facturado=0').then((response: AxiosResponse) => {
      return response.data.length ? true : false;
    });
  },
  async checkByPass(): Promise<boolean> {
    const explotacion = await useExplotacionStore().get;
    return api.get('/v2/explotacion/check-by-pass-nc/'+explotacion.id).then((response: AxiosResponse) => {
      return response.data === 0 ? false : true;
    });
  },
  async decargarContrato(): Promise<Archivo> {
    const explotacion = await useExplotacionStore().get;
    return api.get('/v2/explotacion/descargar-contrato/'+explotacion.id).then((response: AxiosResponse) => {
      return response.data;
    });
  }
};
